
<div class="card-body">
  <nav class="navbar navbar-light bg-light navbar-expand-lg p-2">
    <div #buscador class="collapse navbar-collapse d-flex align-items-center" id="navbarSupportedContent">
      <!-- Buscar cliente -->
      <div class="form-inline me-3">
        <input id="busquedaFormControl" [formControl]="buscadorFormControl" type="text" class="form-control"
          (input)="filtrarAerovales()" placeholder="Búsqueda" />
      </div>
      <ul class="navbar-nav d-flex align-items-center">
  
        <!-- Filtro estados original -->
        <li class="nav-item me-2">
          <div ngbDropdown autoClose="outside">
            <button class="btn btn-outline-primary w-auto" id="dropdownForm1" ngbDropdownToggle>
              Estados aerovale original
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownForm1">
              <div class="px-4 py-3">
                <div *ngFor="let estado of estadosOriginal">
                  <div class="form-check">
                    <input type="checkbox"
                           class="form-check-input me-2"
                           [id]="'dropdownCheck' + estado.valor"
                           [(ngModel)]="estado.seleccionado"
                           (change)="filtrarAerovales()" />
                    <label class="form-check-label text-nowrap"
                           [for]="'dropdownCheck' + estado.valor">
                      {{ estado.descripcion }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
  
        <!-- Filtro estados servicio -->
        <li class="nav-item me-2">
          <div ngbDropdown autoClose="outside">
            <button class="btn btn-outline-primary w-auto" id="dropdownForm2" ngbDropdownToggle>
              Estados aerovale servicio
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownForm2">
              <div class="px-4 py-3">
                <div *ngFor="let estado of estadosServicio">
                  <div class="form-check">
                    <input type="checkbox"
                           class="form-check-input me-2"
                           [id]="'dropdownCheck2' + estado.valor"
                           [(ngModel)]="estado.seleccionado"
                           (change)="filtrarAerovales()" />
                    <label class="form-check-label text-nowrap"
                           [for]="'dropdownCheck2' + estado.valor">
                      {{ estado.descripcion }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
  
        <!-- Inputs de fecha -->
        <li class="nav-item me-2">
          <div class="input-group">
              <input type="date" [ngModel]="modelDesde"
                  placeholder="aaaa-mm-dd" (ngModelChange)="modelDesde = $event" name="dt" ngbDatepicker
                  #d="ngbDatepicker" value="model" class="form-control form-control-rounded" #id="ngbDatepicker"
                  #searchDate required readonly>

              <div class="input-group-append">
                  <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary"
                      (click)="toggleDatepicker(d)">
                      <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
              </div>
          </div>
      </li>

      <li class="nav-item me-2">
          <div class="input-group">
              <input type="date" [ngModel]="modelHasta"
                  placeholder="aaaa-mm-dd" (ngModelChange)="modelHasta = $event" name="dt" ngbDatepicker
                  #h="ngbDatepicker" value="model" class="form-control form-control-rounded" #id="ngbDatepicker"
                  #searchDate required readonly>

              <div class="input-group-append">
                  <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary"
                      (click)="toggleDatepicker(h)">
                      <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
              </div>
          </div>
      </li>
      <li class="nav-item">
        <button (click)="obtenerAerovales()" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit"><i
            class="fa fa-search" aria-hidden="true"></i></button>
      </li>
      </ul>
  
      <div class="ms-2">
        <button type="button" class="btn btn-outline-primary" [disabled]="!habilitarBotones || this.aerovalesFiltrados.length == 0" (click)="exportarExcel()">
          <i class="fa fa-file-excel-o"></i> Exportar
        </button>
      </div>
    </div>
  </nav>

  @if(cargandoAerovales) {
    <div class="col col-md-12" >
      <div class="spinner-container">
        <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd
          Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
          <p style="color: white">C a r g a n d o . . . </p>
        </ngx-spinner>
      </div>
    </div>
  } @else if(aerovalesFiltrados.length > 0) {

    <table *ngIf="!cargandoAerovales" class="table table-striped table-hover letra">
      <thead class="text-center">
        <tr>
          <th>Raz&oacute;n Social</th>
          <th>Cuenta</th>
          <th>Aeroplanta</th>
          <th>Aerovale Origen</th>
          <th>Cliente a imputar</th>
          <th>Cuenta a imputar</th>
          <th>Aerovale servicio</th>
          <th>Fecha aerovale</th>
          <th>Cantidad</th>
          <th>Remito</th>
          <th>Factura</th>
          <th>Fecha factura</th>
          <th>Acci&oacute;n</th>
        </tr>
      </thead>
      <tbody class="text-center">
        <tr *ngFor="let aerovale of aerovalesFiltrados; let i = index">
          <td>{{aerovale.razonSocial}}</td>
          <td>{{aerovale.cuenta}}</td>
          <td>{{aerovale.aeroplanta}}</td>
          <td><span [ngClass]="{'anulado': esAnulado(aerovale.aerovaleOrigen)}">{{aerovale.aerovaleOrigen.prefijo | aerovalePrefijo}}{{aerovale.aerovaleOrigen.numeroAerovale | aerovaleNumero}} </span> <i [ngClass]="[cargandoAerovaleOrigen == i ? 'fa fa-spinner fa-spin' : 'fa fa-eye']"(click)="mostrarAerovale(aerovale.aerovaleOrigen.id, i, true)" class="fa fa-eye"></i></td>
          <td>{{aerovale.clienteImputar}}</td>
          <td>{{aerovale.cuentaImputar}}</td>
          <td><span [ngClass]="{'anulado': esAnulado(aerovale.aerovaleServicio)}">{{aerovale.aerovaleServicio.prefijo | aerovalePrefijo}}{{aerovale.aerovaleServicio.numeroAerovale | aerovaleNumero}} </span> <i [ngClass]="[cargandoAerovaleServicio == i ? 'fa fa-spinner fa-spin' : 'fa fa-eye']" (click)="mostrarAerovale(aerovale.aerovaleServicio.id, i, false)" class="fa fa-eye"></i></td>
          <td>{{aerovale.fechaAerovale | date: "dd'/'MM'/'yy"}} </td>
          <td>{{aerovale.cantidad | number: '1.0-0'}}</td>
          <td>{{aerovale.remito?.prefijo | remitoPrefijo}}-{{aerovale.remito?.numeroRemito | remitoNumero}} @if(aerovale.remito){ <i [ngClass]="[cargandoRemito == i ? 'fa fa-spinner fa-spin' : 'fa fa-eye']" (click)="verRemito(aerovale, i)" class="fa fa-eye"></i> }</td>
          <td>{{aerovale.factura?.factura}} @if(aerovale.factura) { <i [ngClass]="[cargandoFactura == i ? 'fa fa-spinner fa-spin' : 'fa fa-eye']" (click)="mostrarComprobante(aerovale.factura.id, i, true)" class="fa fa-eye"></i>}</td>
          <td>{{aerovale.factura?.fechaFactura | date: "dd'/'MM'/'yy"}}</td>
          <td>@if(!esAnulado(aerovale.aerovaleServicio)){<button (click)="anularAerovale(aerovale.aerovaleServicio.id, i)" class="btn btn-danger">Anular</button>}</td>
        </tr>
      </tbody>
    </table>
  } @else {
    <ngb-alert type="warning" class="alert alert warning">
      No existen aerovales para el per&iacute;odo seleccionado.
     </ngb-alert>
  }
  

</div>